import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';

import App from 'pages/app';
import MainContainer from 'pages/mainContainer';
import Authentication from 'pages/authentication/authentication';
import AuthenticationNew from 'pages/authentication/authenticationNew';
import SsoLogin from 'pages/authentication/ssoLogin';
import SsoError from 'pages/authentication/ssoError';
import Login from 'pages/authentication/login';

import Job from 'pages/job/job';
import JobInProgress from 'pages/job/inProgress';
import JobSubmission from 'pages/job/submissions';
import JobNew from 'pages/job/new';
import JobModule from 'modules/job';
import TaskModule from 'modules/task';

import Notification from 'pages/notification';

import ArchiveTask from 'pages/archive/task';
import ArchiveJob from 'pages/archive/job';

import PageNotFound from 'pages/pageNotFound';

// Note: For components rendered directly by Route (i.e. all components found in this file),
// router props { history, location, match } are available, since they are passed via {...props}.
// Otherwise, use withRouter(Component) to link it
// https://stackoverflow.com/a/53916596
// use withRouter outside of connect() wrapper in case redux blocks updates
// https://github.com/remix-run/react-router/blob/v4.3.1/packages/react-router/docs/guides/blocked-updates.md#shouldcomponentupdate

// React router 4 deals away with the centralized router, and it is probably better
// to define respective routes in the various components instead.
// TODO: restructure routes to reduce repetition (can reference https://css-tricks.com/react-router-4/)
const routes = (
  <Routes>
    <Route element={<App />}>
      <Route element={<Navigate replace to="/auth/login" />} path="/auth" />
      <Route element={<Navigate replace to="/submissions" />} path="/home" />
      <Route element={<Navigate replace to="/auth/login" />} path="/" />
      <Route element={<Navigate replace to="/archives/tasks" />} path="/archives" />

      <Route element={<AuthenticationNew />} path="/auth/login/sso/*">
        <Route element={<SsoError />} path=":domain/error" />
        <Route element={<SsoLogin />} path=":domain" />
        <Route element={<PageNotFound />} path="*" />
      </Route>

      <Route
        element={(
          <Authentication>
            <Login />
          </Authentication>
        )}
        path="/auth/login"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobSubmission />
            </Job>
          </MainContainer>
        )}
        path="/submissions"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobNew />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/new"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobModule.ImportForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/import"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobModule.ExportForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/export"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobModule.NewTaskForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/:id/new_task"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobModule.EditForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/:id/edit"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobSubmission>
                <JobModule.ViewForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/jobs/:id"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobSubmission>
                <TaskModule.ViewForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/tasks/:id"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobSubmission>
                <TaskModule.EditForm />
              </JobSubmission>
            </Job>
          </MainContainer>
        )}
        path="/submissions/tasks/:id/edit"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobInProgress />
            </Job>
          </MainContainer>
        )}
        path="/in_progress"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobNew />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/new"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobModule.ImportForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/import"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobModule.ExportForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/export"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobModule.NewTaskForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/:id/new_task"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobModule.EditForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/:id/edit"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobInProgress>
                <JobModule.ViewForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/jobs/:id"
      />

      <Route
        element={(
          <MainContainer titleKey="myJobs">
            <Job>
              <JobInProgress>
                <TaskModule.ViewForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/tasks/:id"
      />

      <Route
        element={(
          <MainContainer editOnly titleKey="myJobs">
            <Job>
              <JobInProgress>
                <TaskModule.EditForm />
              </JobInProgress>
            </Job>
          </MainContainer>
        )}
        path="/in_progress/tasks/:id/edit"
      />

      <Route
        element={(
          <MainContainer titleKey="notifications">
            <Notification />
          </MainContainer>
        )}
        path="/notifications"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveTask />
          </MainContainer>
        )}
        path="/archives/tasks"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveTask>
              <TaskModule.ViewForm />
            </ArchiveTask>
          </MainContainer>
        )}
        path="/archives/tasks/:id"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveJob />
          </MainContainer>
        )}
        path="/archives/jobs"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveJob>
              <JobModule.ViewForm />
            </ArchiveJob>
          </MainContainer>
        )}
        path="/archives/jobs/:id"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveJob>
              <JobModule.EditForm />
            </ArchiveJob>
          </MainContainer>
        )}
        path="/archives/jobs/:id/edit"
      />

      <Route
        element={(
          <MainContainer titleKey="archives">
            <ArchiveJob>
              <JobModule.NewTaskForm />
            </ArchiveJob>
          </MainContainer>
        )}
        path="/archives/jobs/:id/new_task"
      />

      <Route element={<PageNotFound />} path="*" />
    </Route>
  </Routes>
);

export default routes;
